import { sagas as companyLinksSagas } from './modules/companyLinks'

export default [...companyLinksSagas]
